import React from 'react'

import {
    Create,
    required,
    SimpleForm,
    useNotify,
    useRedirect,
    useTranslate,
} from 'react-admin'
import { Typography, useMediaQuery, useTheme } from '@mui/material';
import styledFormInputs from '../../../ui/inputs/styledFormInputs';
import { isSuperAdmin } from '../../../helper/resourceHelper';
import NavigateBackBtn from '../../../ui/button/NavigateBackBtn';



const validateRequired = [required('Champs obligatoire')]


const SmsCreditPlanCreate = ({ classes, ...props }) => {
    const translate = useTranslate();
    const theme = useTheme();
    const notify = useNotify();
    const redirect = useRedirect();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    const inputsDataGeneral = [
        { name: 'title_fr', label: translate('resources.sms_credit_plans.title_fr'), validate: validateRequired, type: "text" },
        { name: 'description_fr', label: translate('resources.sms_credit_plans.description_fr'), validate: validateRequired,  width: isSmall ? "300px" : "480px", type: "text" },
        { name: 'title_en', label: translate('resources.sms_credit_plans.title_en'), validate: validateRequired, type: "text" },
        { name: 'description_en', label: translate('resources.sms_credit_plans.description_en'), validate: validateRequired,  width: isSmall ? "300px" : "480px", type: "text" },
        { name: 'title_es', label: translate('resources.sms_credit_plans.title_es'), validate: validateRequired, type: "text" },
        { name: 'description_es', label: translate('resources.sms_credit_plans.description_es'), validate: validateRequired,  width: isSmall ? "300px" : "480px", type: "text" },
        { name: 'root_organization_id', label: translate('resources.sms_credit_plans.root_organization_id'), validate: validateRequired, type: "reference", reference: "root_organizations", optionText: "name" },
        { name: 'is_default', label: translate('resources.sms_credit_plans.is_default'), validate: validateRequired, type: "boolean" },
    ]

    const inputsDataPricing = [
        { name: 'sms_quantity', label: translate('resources.sms_credit_plans.sms_quantity'), validate: validateRequired, type: "number" },
        { name: 'amount', label: translate('resources.sms_credit_plans.amount'), validate: validateRequired, type: "number" },
        { name: 'tax_percent', label: translate('resources.sms_credit_plans.tax_percent'), validate: validateRequired, type: "number" },
        { name: 'currency', label: translate('resources.sms_credit_plans.currency'), validate: validateRequired, type: "select", choices: [{ id: 'eur', name: 'EUR' }, { id: 'aud', name: 'AUD' }, { id: 'nzd', name: 'NZD' }, { id: 'usd', name: 'USD' }] },
        { name: 'payment_method_type', label: translate('resources.sms_credit_plans.payment_method_type'), validate: validateRequired, type: "select", choices: [{ id: 'card', name: 'CARD' }, { id: 'sepa_debit', name: 'SEPA_DEBIT' }] },
    ]

    const inputsDataAppOwnerFees = [
        { name: 'app_owner_percent_fees', label: translate('resources.sms_credit_plans.app_owner_percent_fees'), validate: validateRequired, type: "number" },
        { name: 'app_owner_fixed_fees', label: translate('resources.sms_credit_plans.app_owner_fixed_fees'), validate: validateRequired, type: "number" },
    ]

    const onSuccess = () => {
        notify(translate('resources.sms_credit_plans.create_success'));
        redirect('/sms_credit_plans');
    }

    return (
        <>
            <Typography sx={{ color: theme.palette.text.primary, textAlign: 'start', fontWeight: 700, fontSize: "24px", lineHeight: "42px", margin: "0px 0px 16px 0px" }}>
                <NavigateBackBtn /> {translate('resources.sms_credit_plans.create')}
            </Typography>
            <Create
                redirect="list"
                title={'resources.sms_credit_plans.create'}
                sx={{
                    "& .MuiPaper-root": {
                        backgroundColor: theme.palette.background.paper,
                        color: theme.palette.text.primary,
                    },
                }}
                mutationOptions={{ onSuccess }}
            >
                <SimpleForm >
                    <Typography color="text.main" sx={{
                        fontFamily: "Roboto",
                        fontSize: "16px",
                        fontWeight: 700,
                        lineHeight: "25px",
                        textAlign: "center",
                        margin: "0px 0px 10px 0px"
                    }}
                    >
                        {translate('resources.sms_credit_plans.sections.general')}
                    </Typography>
                    {styledFormInputs(inputsDataGeneral)}
                    <Typography color="text.main" sx={{
                        fontFamily: "Roboto",
                        fontSize: "16px",
                        fontWeight: 700,
                        lineHeight: "25px",
                        textAlign: "center",
                        margin: "20px 0px 10px 0px"
                    }}
                    >
                        {translate('resources.sms_credit_plans.sections.pricing')}
                    </Typography>
                    {styledFormInputs(inputsDataPricing)}
                    {isSuperAdmin() && <Typography color="text.main" sx={{
                        fontFamily: "Roboto",
                        fontSize: "16px",
                        fontWeight: 700,
                        lineHeight: "25px",
                        textAlign: "center",
                        margin: "20px 0px 10px 0px"
                    }}
                    >
                        {translate('resources.sms_credit_plans.sections.app_owner_fees')}
                    </Typography>}
                    {isSuperAdmin() && styledFormInputs(inputsDataAppOwnerFees)}

                </SimpleForm>
            </Create>
        </>
    )
}

export default SmsCreditPlanCreate



